import { FC, ReactNode } from 'react';
import { Page } from './ExamImportHeader.styles';
import { useTranslation } from 'react-i18next';
import { LuxAlert, Stack, Typography, Box } from '@gemini/fe-ds-core';
import VisionXLogo from '@components/Icons/VisionXLogo';

interface ExamImportHeaderProps {
  children?: ReactNode;
}

const ExamImportHeader: FC<ExamImportHeaderProps> = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <Stack flexDirection={'row'} width={'100%'}>
        <VisionXLogo />
        <Typography
          variant="heading2"
          color={'#002855'}
          style={{ paddingLeft: 12 }}
        >
          {t('examImport.title')}
        </Typography>
        <Box marginLeft={'auto'}>
          <LuxAlert
            type="informative"
            closable={true}
            customIcon='StarEmptyIcon'
            showCloseButton={true}
            title={t('examImport.tooltip') ?? ''}
            sx={{
              height: '48px',
              alignItems: 'center !important',
              '& .MuiTypography-root': { marginBottom: 0 },
              '& > .MuiStack-root': { gap: 0 },
            }}
          />
        </Box>
      </Stack>
    </Page>
  );
};

export default ExamImportHeader;
